__turbopack_context__.v({
  "isOpen": "Portal-module-scss-module__JFJCKq__isOpen",
  "overlay": "Portal-module-scss-module__JFJCKq__overlay",
});
